export enum ProposalKind {
  Entity = 'entity',
  Gift = 'gift',
  CLT = 'clt',
  CRT = 'crt',
}
